import React from 'react';

const AdPoster1 = () => {
  return (
    <section className="py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl overflow-hidden shadow-xl">
          <img
            src="https://res.cloudinary.com/dgban38oz/image/upload/v1759922768/cld-sample-4.jpg"
            alt="Ceremonzy wedding vendor promotional banner - Discover premium wedding services"
            className="w-full h-64 object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default AdPoster1;